import { createAsyncThunk, createSelector, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { empresaIdsSelector, isClienteOperadorSelector, isOperadorSelector } from "./autenticacao";
import { filter } from "compression";

const initialState = {
  // CABECALHO

  cabecalho: {},

  // CADASTRO

  cadastro: {},
  cadastroAlertaGrupo: {},


  assistente: {
    empresa: {},
    unidades: [],
    socios: [],
  },

  // UNIDADES

  unidades: [],
  unidadesSearch: "",
  unidadesAlertaGrupo: {},
  unidade: {},

  // CERTIFICADOS

  certificados: [],
  certificadosSearch: "",
  certificadosAlertaGrupo: {},
  certificado: {},

  // TRIBUTARIOS

  tributarios: [],
  tributariosSearch: "",
  tributariosAlertaGrupo: {},
  tributario: {},

  // SÓCIOS

  socios: [],
  sociosSearch: "",
  sociosAlertaGrupo: {},
  socio: {},

  // CONTRATOS

  contratos: [],
  contratosOrgao: "",
  contratosSearch: "",
  contratosAlertaGrupo: {},
  contrato: {},

  // PLS

  pls: [],
  plsSearch: "",
  plsAlertaGrupo: {},
  pl: {},

  // ADMINISTRADORES

  administradores: [],
  administradoresSearch: "",
  administradoresAlertaGrupo: {},
  administrador: {},

  // PROCURADORES

  procuradores: [],
  procuradoresSearch: "",
  procuradoresAlertaGrupo: {},
  procurador: {},

  // CONTAS

  contas: [],
  contasSearch: "",
  contasAlertaGrupo: {},
  conta: {},

  // BENEFICIÁRIOS EMPRESA

  beneficiariosEmpresa: [],
  beneficiariosEmpresaSearch: "",
  beneficiariosEmpresaAlertaGrupo: {},
  beneficiarioEmpresa: {},

  // REPRESENTANTES

  representantes: [],
  representantesSearch: "",
  representantesAlertaGrupo: {},
  representante: {},

  // BENEFICIÁRIOS SÓCIO

  beneficiariosSocio: [],
  beneficiariosSocioSearch: "",
  beneficiariosSocioAlertaGrupo: {},
  beneficiarioSocio: {},

  // IEDS

  rdeieds: [],
  rdeiedsSearch: "",
  rdeiedsAlertaGrupo: {},
  rdeied: {},

  // DEFs

  defs: [],
  defsSearch: "",
  defsAlertaGrupo: {},
  def: {},

  // CCEs

  cces: [],
  ccesSearch: "",
  ccesAlertaGrupo: {},
  cce: {},

  // CBEs

  cbes: [],
  cbesSearch: "",
  cbesAlertaGrupo: {},
  cbe: {},

  // LICENÇAS

  licencas: [],
  licencasSearch: "",
  licencasFilterDate: null,
  licencasUnidade: null,
  licencasAlertaGrupo: {},
  licenca: {},

  // DOCUMENTOS

  documentos: [],
  documentosSearch: "",
  documentosAlertaGrupo: {},
  documento: {},

  // LIVROS DIGITAIS

  livrosDigitais: [],
  livrosDigitaisSearch: "",
  livrosDigitaisAlertaGrupo: {},
  livroDigital: {},
};

// CABECALHO

export const cabecalhoSelector = (state) => state.empresa.cabecalho;


// Selector para o objeto completo do assistente
export const assistenteSelector = (state) => state.empresa.assistente;

// Selector apenas para os sócios
export const sociosAssistenteSelector = (state) => state.empresa.socios || [];

// Selector apenas para as unidades
export const unidadesAssistenteSelector = (state) => state.empresa.unidades || [];



// CADASTRO

export const cadastroSelector = (state) => state.empresa.cadastro;
export const cadastroAlertaGrupoSelector = (state) => state.empresa.cadastroAlertaGrupo;

export const cadastroAlertaNivelSelector = createSelector(cadastroAlertaGrupoSelector, (alertaGrupo) => alertaGrupo?.nivel ?? 0);
export const cadastroAlertasSelector = createSelector(cadastroAlertaGrupoSelector, (alertaGrupo) => alertaGrupo?.alertas ?? []);

// UNIDADES

export const unidadesSelector = (state) => state.empresa.unidades;
export const unidadesSearchSelector = (state) => state.empresa.unidadesSearch;
export const unidadesAlertaGrupoSelector = (state) => state.empresa.unidadesAlertaGrupo;
export const unidadeSelector = (state) => state.empresa.unidade;

export const unidadesAlertaNivelSelector = createSelector(unidadesAlertaGrupoSelector, (alertaGrupo) => alertaGrupo?.nivel ?? 0);
export const unidadesAlertasSelector = createSelector(unidadesAlertaGrupoSelector, (alertaGrupo) => alertaGrupo?.alertas ?? []);

// CERTIFICADOS

export const certificadosSelector = (state) => state.empresa.certificados;
export const certificadosSearchSelector = (state) => state.empresa.certificadosSearch;
export const certificadosAlertaGrupoSelector = (state) => state.empresa.certificadosAlertaGrupo;
export const certificadoSelector = (state) => state.empresa.certificado;

export const certificadosAlertaNivelSelector = createSelector(certificadosAlertaGrupoSelector, (alertaGrupo) => alertaGrupo?.nivel ?? 0);
export const certificadosAlertasSelector = createSelector(certificadosAlertaGrupoSelector, (alertaGrupo) => alertaGrupo?.alertas ?? []);

// TRIBUTARIOS

export const tributariosSelector = (state) => state.empresa.tributarios;
export const tributariosSearchSelector = (state) => state.empresa.tributariosSearch;
export const tributariosAlertaGrupoSelector = (state) => state.empresa.tributariosAlertaGrupo;
export const tributarioSelector = (state) => state.empresa.tributario;

export const tributariosAlertaNivelSelector = createSelector(tributariosAlertaGrupoSelector, (alertaGrupo) => alertaGrupo?.nivel ?? 0);
export const tributariosAlertasSelector = createSelector(tributariosAlertaGrupoSelector, (alertaGrupo) => alertaGrupo?.alertas ?? []);

// SÓCIOS

export const sociosSelector = (state) => state.empresa.socios;
export const sociosSearchSelector = (state) => state.empresa.sociosSearch;
export const sociosAlertaGrupoSelector = (state) => state.empresa.sociosAlertaGrupo;
export const socioSelector = (state) => state.empresa.socio;

export const sociosAlertaNivelSelector = createSelector(sociosAlertaGrupoSelector, (alertaGrupo) => alertaGrupo?.nivel ?? 0);
export const sociosAlertasSelector = createSelector(sociosAlertaGrupoSelector, (alertaGrupo) => alertaGrupo?.alertas ?? []);

// CONTRATOS

export const contratosSelector = (state) => state.empresa.contratos;
export const contratosOrgaoSelector = (state) => state.empresa.contratosOrgao;
export const contratosSearchSelector = (state) => state.empresa.contratosSearch;
export const contratosAlertaGrupoSelector = (state) => state.empresa.contratosAlertaGrupo;
export const contratoSelector = (state) => state.empresa.contrato;

export const contratosAlertaNivelSelector = createSelector(contratosAlertaGrupoSelector, (alertaGrupo) => alertaGrupo?.nivel ?? 0);
export const contratosAlertasSelector = createSelector(contratosAlertaGrupoSelector, (alertaGrupo) => alertaGrupo?.alertas ?? []);

// PLS

export const plsSelector = (state) => state.empresa.pls;
export const plsSearchSelector = (state) => state.empresa.plsSearch;
export const plsAlertaGrupoSelector = (state) => state.empresa.plsAlertaGrupo;
export const plSelector = (state) => state.empresa.pl;

export const plsAlertaNivelSelector = createSelector(plsAlertaGrupoSelector, (alertaGrupo) => alertaGrupo?.nivel ?? 0);
export const plsAlertasSelector = createSelector(plsAlertaGrupoSelector, (alertaGrupo) => alertaGrupo?.alertas ?? []);

// ADMINISTRADORES

export const administradoresSelector = (state) => state.empresa.administradores;
export const administradoresSearchSelector = (state) => state.empresa.administradoresSearch;
export const administradoresAlertaGrupoSelector = (state) => state.empresa.administradoresAlertaGrupo;
export const administradoreSelector = (state) => state.empresa.administrador;

export const administradoresAlertaNivelSelector = createSelector(administradoresAlertaGrupoSelector, (alertaGrupo) => alertaGrupo?.nivel ?? 0);
export const administradoresAlertasSelector = createSelector(administradoresAlertaGrupoSelector, (alertaGrupo) => alertaGrupo?.alertas ?? []);

// PROCURADORES

export const procuradoresSelector = (state) => state.empresa.procuradores;
export const procuradoresSearchSelector = (state) => state.empresa.procuradoresSearch;
export const procuradoresAlertaGrupoSelector = (state) => state.empresa.procuradoresAlertaGrupo;
export const procuradoreSelector = (state) => state.empresa.procurador;

export const procuradoresAlertaNivelSelector = createSelector(procuradoresAlertaGrupoSelector, (alertaGrupo) => alertaGrupo?.nivel ?? 0);
export const procuradoresAlertasSelector = createSelector(procuradoresAlertaGrupoSelector, (alertaGrupo) => alertaGrupo?.alertas ?? []);

// CONTAS

export const contasSelector = (state) => state.empresa.contas;
export const contasSearchSelector = (state) => state.empresa.contasSearch;
export const contasAlertaGrupoSelector = (state) => state.empresa.contasAlertaGrupo;
export const contaSelector = (state) => state.empresa.conta;

export const contasAlertaNivelSelector = createSelector(contasAlertaGrupoSelector, (alertaGrupo) => alertaGrupo?.nivel ?? 0);
export const contasAlertasSelector = createSelector(contasAlertaGrupoSelector, (alertaGrupo) => alertaGrupo?.alertas ?? []);

// BENEFICIÁRIOS EMPRESA

export const beneficiariosEmpresaSelector = (state) => state.empresa.beneficiariosEmpresa;
export const beneficiariosEmpresaSearchSelector = (state) => state.empresa.beneficiariosEmpresaSearch;
export const beneficiariosEmpresaAlertaGrupoSelector = (state) => state.empresa.beneficiariosEmpresaAlertaGrupo;
export const beneficiariosEmpresaelector = (state) => state.empresa.beneficiarioEmpresa;

export const beneficiariosEmpresaAlertaNivelSelector = createSelector(beneficiariosEmpresaAlertaGrupoSelector, (alertaGrupo) => alertaGrupo?.nivel ?? 0);
export const beneficiariosEmpresaAlertasSelector = createSelector(beneficiariosEmpresaAlertaGrupoSelector, (alertaGrupo) => alertaGrupo?.alertas ?? []);

// REPRESENTANTES

export const representantesSelector = (state) => state.empresa.representantes;
export const representantesSearchSelector = (state) => state.empresa.representantesSearch;
export const representantesAlertaGrupoSelector = (state) => state.empresa.representantesAlertaGrupo;
export const representanteSelector = (state) => state.empresa.representante;

export const representantesAlertaNivelSelector = createSelector(representantesAlertaGrupoSelector, (alertaGrupo) => alertaGrupo?.nivel ?? 0);
export const representantesAlertasSelector = createSelector(representantesAlertaGrupoSelector, (alertaGrupo) => alertaGrupo?.alertas ?? []);

// BENEFICIÁRIOS SÓCIO

export const beneficiariosSocioSelector = (state) => state.empresa.beneficiariosSocio;
export const beneficiariosSocioSearchSelector = (state) => state.empresa.beneficiariosSocioSearch;
export const beneficiariosSocioAlertaGrupoSelector = (state) => state.empresa.beneficiariosSocioAlertaGrupo;
export const beneficiariosSocioelector = (state) => state.empresa.beneficiarioSocio;

export const beneficiariosSocioAlertaNivelSelector = createSelector(beneficiariosSocioAlertaGrupoSelector, (alertaGrupo) => alertaGrupo?.nivel ?? 0);
export const beneficiariosSocioAlertasSelector = createSelector(beneficiariosSocioAlertaGrupoSelector, (alertaGrupo) => alertaGrupo?.alertas ?? []);

// RDEIEDS

export const rdeiedsSelector = (state) => state.empresa.rdeieds;
export const rdeiedsSearchSelector = (state) => state.empresa.rdeiedsSearch;
export const rdeiedsAlertaGrupoSelector = (state) => state.empresa.rdeiedsAlertaGrupo;
export const rdeiedSelector = (state) => state.empresa.rdeied;

export const rdeiedsAlertaNivelSelector = createSelector(rdeiedsAlertaGrupoSelector, (alertaGrupo) => alertaGrupo?.nivel ?? 0);
export const rdeiedsAlertasSelector = createSelector(rdeiedsAlertaGrupoSelector, (alertaGrupo) => alertaGrupo?.alertas ?? []);

// DEFs

export const defsSelector = (state) => state.empresa.defs;
export const defsSearchSelector = (state) => state.empresa.defsSearch;
export const defsAlertaGrupoSelector = (state) => state.empresa.defsAlertaGrupo;
export const defSelector = (state) => state.empresa.def;

export const defsAlertaNivelSelector = createSelector(defsAlertaGrupoSelector, (alertaGrupo) => alertaGrupo?.nivel ?? 0);
export const defsAlertasSelector = createSelector(defsAlertaGrupoSelector, (alertaGrupo) => alertaGrupo?.alertas ?? []);

// CCEs

export const ccesSelector = (state) => state.empresa.cces;
export const ccesSearchSelector = (state) => state.empresa.ccesSearch;
export const ccesAlertaGrupoSelector = (state) => state.empresa.ccesAlertaGrupo;
export const cceSelector = (state) => state.empresa.cce;

export const ccesAlertaNivelSelector = createSelector(ccesAlertaGrupoSelector, (alertaGrupo) => alertaGrupo?.nivel ?? 0);
export const ccesAlertasSelector = createSelector(ccesAlertaGrupoSelector, (alertaGrupo) => alertaGrupo?.alertas ?? []);

// CBEs

export const cbesSelector = (state) => state.empresa.cbes;
export const cbesSearchSelector = (state) => state.empresa.cbesSearch;
export const cbesAlertaGrupoSelector = (state) => state.empresa.cbesAlertaGrupo;
export const cbeSelector = (state) => state.empresa.cbe;

export const cbesAlertaNivelSelector = createSelector(cbesAlertaGrupoSelector, (alertaGrupo) => alertaGrupo?.nivel ?? 0);
export const cbesAlertasSelector = createSelector(cbesAlertaGrupoSelector, (alertaGrupo) => alertaGrupo?.alertas ?? []);

// LICENÇAS

export const licencasSelector = (state) => state.empresa.licencas;
export const licencasSearchSelector = (state) => state.empresa.licencasSearch;
export const licencasFilterDateSelector = (state) => state.empresa.licencasFilterDate;
export const licencasUnidadeSelector = (state) => state.empresa.licencasUnidade;
export const licencasAlertaGrupoSelector = (state) => state.empresa.licencasAlertaGrupo;
export const licencaSelector = (state) => state.empresa.licenca;

export const licencasAlertaNivelSelector = createSelector(licencasAlertaGrupoSelector, (alertaGrupo) => alertaGrupo?.nivel ?? 0);
export const licencasAlertasSelector = createSelector(licencasAlertaGrupoSelector, (alertaGrupo) => alertaGrupo?.alertas ?? []);

// DOCUMENTOS

export const documentosSelector = (state) => state.empresa.documentos;
export const documentosSearchSelector = (state) => state.empresa.documentosSearch;
export const documentosAlertaGrupoSelector = (state) => state.empresa.documentosAlertaGrupo;
export const documentoSelector = (state) => state.empresa.documento;

export const documentosAlertaNivelSelector = createSelector(documentosAlertaGrupoSelector, (alertaGrupo) => alertaGrupo?.nivel ?? 0);
export const documentosAlertasSelector = createSelector(documentosAlertaGrupoSelector, (alertaGrupo) => alertaGrupo?.alertas ?? []);

// LIVROS DIGITAIS

export const livrosDigitaisSelector = (state) => state.empresa.livrosDigitais;
export const livrosDigitaisSearchSelector = (state) => state.empresa.livrosDigitaisSearch;
export const livrosDigitaisAlertaGrupoSelector = (state) => state.empresa.livrosDigitaisAlertaGrupo;
export const livroDigitalSelector = (state) => state.empresa.livroDigital;

export const livrosDigitaisAlertaNivelSelector = createSelector(livrosDigitaisAlertaGrupoSelector, (alertaGrupo) => alertaGrupo?.nivel ?? 0);
export const livrosDigitaisAlertasSelector = createSelector(livrosDigitaisAlertaGrupoSelector, (alertaGrupo) => alertaGrupo?.alertas ?? []);

// ALERTA

export const alertaGrupoSelector = createSelector(
  cadastroAlertaGrupoSelector,
  unidadesAlertaGrupoSelector,
  certificadosAlertaGrupoSelector,
  tributariosAlertaGrupoSelector,
  sociosAlertaGrupoSelector,
  contratosAlertaGrupoSelector,
  plsAlertaGrupoSelector,
  administradoresAlertaGrupoSelector,
  procuradoresAlertaGrupoSelector,
  contasAlertaGrupoSelector,
  beneficiariosEmpresaAlertaGrupoSelector,
  representantesAlertaGrupoSelector,
  beneficiariosSocioAlertaGrupoSelector,
  rdeiedsAlertaGrupoSelector,
  defsAlertaGrupoSelector,
  ccesAlertaGrupoSelector,
  cbesAlertaGrupoSelector,
  licencasAlertaGrupoSelector,
  documentosAlertaGrupoSelector,
  livrosDigitaisAlertaGrupoSelector,
  (
    cadastroAlertaGrupo,
    unidadesAlertaGrupo,
    certificadosAlertaGrupo,
    tributariosAlertaGrupo,
    sociosAlertaGrupo,
    contratosAlertaGrupo,
    plsAlertaGrupo,
    administradoresAlertaGrupo,
    procuradoresAlertaGrupo,
    contasAlertaGrupo,
    beneficiariosEmpresaAlertaGrupo,
    representantesAlertaGrupo,
    beneficiariosSocioAlertaGrupo,
    rdeiedsAlertaGrupo,
    defsAlertaGrupo,
    ccesAlertaGrupo,
    cbesAlertaGrupo,
    licencasAlertaGrupo,
    documentosAlertaGrupo,
    livrosDigitaisAlertaGrupo,
  ) => ({
    cadastro: cadastroAlertaGrupo ?? {},
    unidades: unidadesAlertaGrupo ?? {},
    certificados: certificadosAlertaGrupo ?? {},
    tributarios: tributariosAlertaGrupo ?? {},
    socios: sociosAlertaGrupo ?? {},
    contratos: contratosAlertaGrupo ?? {},
    pls: plsAlertaGrupo ?? {},
    administradores: administradoresAlertaGrupo ?? {},
    procuradores: procuradoresAlertaGrupo ?? {},
    contas: contasAlertaGrupo ?? {},
    beneficiariosEmpresa: beneficiariosEmpresaAlertaGrupo ?? {},
    representantes: representantesAlertaGrupo ?? {},
    beneficiariosSocio: beneficiariosSocioAlertaGrupo ?? {},
    rdeieds: rdeiedsAlertaGrupo ?? {},
    defs: defsAlertaGrupo ?? {},
    cces: ccesAlertaGrupo ?? {},
    cbes: cbesAlertaGrupo ?? {},
    licencas: licencasAlertaGrupo ?? {},
    documentos: documentosAlertaGrupo ?? {},
    livrosDigitais: livrosDigitaisAlertaGrupo ?? {},
  }),
);

// CABECALHO

export const isEditableSelector = createSelector(cabecalhoSelector, empresaIdsSelector, isClienteOperadorSelector, isOperadorSelector, (cabecalho, empresaIds, isClienteOperador, isOperador) => {
  if (isOperador) return true;
  if (isClienteOperador && empresaIds.includes(cabecalho?.id)) return true;
  return false;
});

export const fetchCabecalho = createAsyncThunk("empresa/fetchCabecalho", async ({ empresaId }, thunkAPI) => {
  try {
    const cabecalho = (await axios.get(`/empresas/${empresaId}/cabecalho`)).data;
    return { cabecalho };
  } catch (e) {
    return thunkAPI.rejectWithValue(e);
  }
});

// CADASTRO

export const fetchCadastro = createAsyncThunk("empresa/fetchCadastro", async ({ empresaId }, thunkAPI) => {
  try {
    const cadastro = (await axios.get(`/empresas/${empresaId}/cadastro`)).data;
    const alertaGrupo = (await axios.get(`/empresas/${empresaId}/cadastro/verificar-alertas`)).data;
    return { cadastro, alertaGrupo };
  } catch (e) {
    return thunkAPI.rejectWithValue(e);
  }
});

// ASSISTENTE

export const fetchAssistente = createAsyncThunk(
  "empresa/fetchAssistente",
  async ({ cnpj }, thunkAPI) => {
    try {
  
      const res = await axios.get(
        `empresas/${cnpj}/assistente/cadastro`
      );
      console.log();
      return res.data;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);


export const criarAssistente = createAsyncThunk(
  "empresa/criarAssistente",
  async (dados, thunkAPI) => {
    try {
      const res = await axios.post("empresas/Assistente", dados);
      return res.data;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response?.data || e.message);
    }
  }
);



// CADASTRO

export const fetchVerificarLimite = createAsyncThunk(
  "empresa/fetchVerificarLimite",
  async (_, thunkAPI) => {
    try {
      const response = await axios.get(`/armazenamento-em-uso/Verificar`);
      return response.data;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);


// UNIDADES

export const fetchUnidades = createAsyncThunk("empresa/fetchUnidades", async ({ empresaId, search }, thunkAPI) => {
  try {
    if (typeof search !== "string") search = thunkAPI.getState().empresa.unidadesSearch;
    const unidades = (
      await axios.get(`/empresas/${empresaId}/unidades`, {
        params: { search },
      })
    ).data;
    const alertaGrupo = (await axios.get(`/empresas/${empresaId}/unidades/verificar-alertas`)).data;
    return { unidades, alertaGrupo };
  } catch (e) {
    return thunkAPI.rejectWithValue(e);
  }
});

export const fetchUnidade = createAsyncThunk("empresa/fetchUnidade", async ({ empresaId, id }, thunkAPI) => {
  try {
    if (id === "create") return {};
    return (await axios.get(`/empresas/${empresaId}/unidades/${id}`)).data;
  } catch (e) {
    return thunkAPI.rejectWithValue(e);
  }
});

// CERTIFICADOS

export const fetchCertificados = createAsyncThunk("empresa/fetchCertificados", async ({ empresaId, search }, thunkAPI) => {
  try {
    if (typeof search !== "string") search = thunkAPI.getState().empresa.certificadosSearch;
    const certificados = (
      await axios.get(`/empresas/${empresaId}/certificados`, {
        params: { search },
      })
    ).data;
    const alertaGrupo = (await axios.get(`/empresas/${empresaId}/certificados/verificar-alertas`)).data;
    return { certificados, alertaGrupo };
  } catch (e) {
    return thunkAPI.rejectWithValue(e);
  }
});

export const fetchCertificado = createAsyncThunk("empresa/fetchCertificado", async ({ empresaId, id }, thunkAPI) => {
  try {
    if (id === "create") return {};
    return (await axios.get(`/empresas/${empresaId}/certificados/${id}`)).data;
  } catch (e) {
    return thunkAPI.rejectWithValue(e);
  }
});

// TRIBUTARIOS

export const fetchTributarios = createAsyncThunk("empresa/fetchTributarios", async ({ empresaId, search }, thunkAPI) => {
  try {
    if (typeof search !== "string") search = thunkAPI.getState().empresa.tributariosSearch;
    const tributarios = (
      await axios.get(`/empresas/${empresaId}/tributarios`, {
        params: { search },
      })
    ).data;
    const alertaGrupo = (await axios.get(`/empresas/${empresaId}/tributarios/verificar-alertas`)).data;
    return { tributarios, alertaGrupo };
  } catch (e) {
    return thunkAPI.rejectWithValue(e);
  }
});

export const fetchTributario = createAsyncThunk("empresa/fetchTributario", async ({ empresaId, id }, thunkAPI) => {
  try {
    if (id === "create") return {};
    return (await axios.get(`/empresas/${empresaId}/tributarios/${id}`)).data;
  } catch (e) {
    return thunkAPI.rejectWithValue(e);
  }
});

// SÓCIOS

export const fetchSocios = createAsyncThunk("empresa/fetchSocios", async ({ empresaId, search }, thunkAPI) => {
  try {
    if (typeof search !== "string") search = thunkAPI.getState().empresa.sociosSearch;
    const socios = (await axios.get(`/empresas/${empresaId}/socios`, { params: { search } })).data;
    const alertaGrupo = (await axios.get(`/empresas/${empresaId}/socios/verificar-alertas`)).data;
    return { socios, alertaGrupo };
  } catch (e) {
    return thunkAPI.rejectWithValue(e);
  }
});

export const fetchSocio = createAsyncThunk("empresa/fetchSocio", async ({ empresaId, id }, thunkAPI) => {
  try {
    if (id === "create") return {};
    return (await axios.get(`/empresas/${empresaId}/socios/${id}`)).data;
  } catch (e) {
    return thunkAPI.rejectWithValue(e);
  }
});

// CONTRATOS

export const fetchContratos = createAsyncThunk("empresa/fetchContratos", async ({ empresaId, orgao, search }, thunkAPI) => {
  try {
    const state = thunkAPI.getState();
    if (typeof orgao !== "number") orgao = state.empresa.contratosOrgao;
    if (typeof search !== "string") search = state.empresa.contratosSearch;
    const contratos = (
      await axios.get(`/empresas/${empresaId}/contratos`, {
        params: { orgao, search },
      })
    ).data;
    const alertaGrupo = (await axios.get(`/empresas/${empresaId}/contratos/verificar-alertas`)).data;
    return { contratos, orgao, search, alertaGrupo };
  } catch (e) {
    return thunkAPI.rejectWithValue(e);
  }
});

export const fetchContrato = createAsyncThunk("empresa/fetchContrato", async ({ empresaId, id }, thunkAPI) => {
  try {
    if (id === "create") return {};
    return (await axios.get(`/empresas/${empresaId}/contratos/${id}`)).data;
  } catch (e) {
    return thunkAPI.rejectWithValue(e);
  }
});

// PLS

export const fetchPLs = createAsyncThunk("empresa/fetchPLs", async ({ empresaId, search }, thunkAPI) => {
  try {
    if (typeof search !== "string") search = thunkAPI.getState().empresa.plsSearch;
    const pls = (await axios.get(`/empresas/${empresaId}/pls`, { params: { search } })).data;
    const alertaGrupo = (await axios.get(`/empresas/${empresaId}/pls/verificar-alertas`)).data;
    return { pls, alertaGrupo };
  } catch (e) {
    return thunkAPI.rejectWithValue(e);
  }
});

export const fetchPL = createAsyncThunk("empresa/fetchPL", async ({ empresaId, id }, thunkAPI) => {
  try {
    if (id === "create") return {};
    return (await axios.get(`/empresas/${empresaId}/pls/${id}`)).data;
  } catch (e) {
    return thunkAPI.rejectWithValue(e);
  }
});

// ADMINISTRADORES

export const fetchAdministradores = createAsyncThunk("empresa/fetchAdministradores", async ({ empresaId, search }, thunkAPI) => {
  try {
    if (typeof search !== "string") search = thunkAPI.getState().empresa.administradoresSearch;
    const administradores = (
      await axios.get(`/empresas/${empresaId}/administradores`, {
        params: { search },
      })
    ).data;
    const alertaGrupo = (await axios.get(`/empresas/${empresaId}/administradores/verificar-alertas`)).data;
    return { administradores, alertaGrupo };
  } catch (e) {
    return thunkAPI.rejectWithValue(e);
  }
});

export const fetchAdministrador = createAsyncThunk("empresa/fetchAdministrador", async ({ empresaId, id }, thunkAPI) => {
  try {
    if (id === "create") return {};
    return (await axios.get(`/empresas/${empresaId}/administradores/${id}`)).data;
  } catch (e) {
    return thunkAPI.rejectWithValue(e);
  }
});

// PROCURADORES

export const fetchProcuradores = createAsyncThunk("empresa/fetchProcuradores", async ({ empresaId, search }, thunkAPI) => {
  try {
    if (typeof search !== "string") search = thunkAPI.getState().empresa.procuradoresSearch;
    const procuradores = (
      await axios.get(`/empresas/${empresaId}/procuradores`, {
        params: { search },
      })
    ).data;
    const alertaGrupo = (await axios.get(`/empresas/${empresaId}/procuradores/verificar-alertas`)).data;
    return { procuradores, alertaGrupo };
  } catch (e) {
    return thunkAPI.rejectWithValue(e);
  }
});

export const fetchProcurador = createAsyncThunk("empresa/fetchProcurador", async ({ empresaId, id }, thunkAPI) => {
  try {
    if (id === "create") return {};
    return (await axios.get(`/empresas/${empresaId}/procuradores/${id}`)).data;
  } catch (e) {
    return thunkAPI.rejectWithValue(e);
  }
});

// CONTAS

export const fetchContas = createAsyncThunk("empresa/fetchContas", async ({ empresaId, search }, thunkAPI) => {
  try {
    if (typeof search !== "string") search = thunkAPI.getState().empresa.contasSearch;
    const contas = (await axios.get(`/empresas/${empresaId}/contas`, { params: { search } })).data;
    const alertaGrupo = (await axios.get(`/empresas/${empresaId}/contas/verificar-alertas`)).data;
    return { contas, alertaGrupo };
  } catch (e) {
    return thunkAPI.rejectWithValue(e);
  }
});

export const fetchConta = createAsyncThunk("empresa/fetchConta", async ({ empresaId, id }, thunkAPI) => {
  try {
    if (id === "create") return {};
    return (await axios.get(`/empresas/${empresaId}/contas/${id}`)).data;
  } catch (e) {
    return thunkAPI.rejectWithValue(e);
  }
});

// BENEFICIÁRIOS EMPRESA

export const fetchBeneficiariosEmpresa = createAsyncThunk("empresa/fetchBeneficiariosEmpresa", async ({ empresaId, search }, thunkAPI) => {
  try {
    if (typeof search !== "string") search = thunkAPI.getState().empresa.beneficiariosEmpresaSearch;
    const beneficiariosEmpresa = (
      await axios.get(`/empresas/${empresaId}/beneficiarios-empresa`, {
        params: { search },
      })
    ).data;
    const alertaGrupo = (await axios.get(`/empresas/${empresaId}/beneficiarios-empresa/verificar-alertas`)).data;
    return { beneficiariosEmpresa, alertaGrupo };
  } catch (e) {
    return thunkAPI.rejectWithValue(e);
  }
});

export const fetchBeneficiarioEmpresa = createAsyncThunk("empresa/fetchBeneficiarioEmpresa", async ({ empresaId, id }, thunkAPI) => {
  try {
    if (id === "create") return {};
    return (await axios.get(`/empresas/${empresaId}/beneficiarios-empresa/${id}`)).data;
  } catch (e) {
    return thunkAPI.rejectWithValue(e);
  }
});

// REPRESENTANTES

export const fetchRepresentantes = createAsyncThunk("empresa/fetchRepresentantes", async ({ empresaId, search }, thunkAPI) => {
  try {
    if (typeof search !== "string") search = thunkAPI.getState().empresa.representantesSearch;
    const representantes = (
      await axios.get(`/empresas/${empresaId}/representantes`, {
        params: { search },
      })
    ).data;
    const alertaGrupo = (await axios.get(`/empresas/${empresaId}/representantes/verificar-alertas`)).data;
    return { representantes, alertaGrupo };
  } catch (e) {
    return thunkAPI.rejectWithValue(e);
  }
});

export const fetchRepresentante = createAsyncThunk("empresa/fetchRepresentante", async ({ empresaId, id }, thunkAPI) => {
  try {
    if (id === "create") return {};
    return (await axios.get(`/empresas/${empresaId}/representantes/${id}`)).data;
  } catch (e) {
    return thunkAPI.rejectWithValue(e);
  }
});

// BENEFICIÁRIOS SÓCIO

export const fetchBeneficiariosSocio = createAsyncThunk("empresa/fetchBeneficiariosSocio", async ({ empresaId, search }, thunkAPI) => {
  try {
    if (typeof search !== "string") search = thunkAPI.getState().empresa.beneficiariosSocioSearch;
    const beneficiariosSocio = (
      await axios.get(`/empresas/${empresaId}/beneficiarios-socio`, {
        params: { search },
      })
    ).data;
    const alertaGrupo = (await axios.get(`/empresas/${empresaId}/beneficiarios-socio/verificar-alertas`)).data;
    return { beneficiariosSocio, alertaGrupo };
  } catch (e) {
    return thunkAPI.rejectWithValue(e);
  }
});

export const fetchBeneficiarioSocio = createAsyncThunk("empresa/fetchBeneficiarioSocio", async ({ empresaId, id }, thunkAPI) => {
  try {
    if (id === "create") return {};
    return (await axios.get(`/empresas/${empresaId}/beneficiarios-socio/${id}`)).data;
  } catch (e) {
    return thunkAPI.rejectWithValue(e);
  }
});

// RDEIEDS

export const fetchRDEIEDs = createAsyncThunk("empresa/fetchRDEIEDs", async ({ empresaId, search }, thunkAPI) => {
  try {
    if (typeof search !== "string") search = thunkAPI.getState().empresa.rdeiedsSearch;
    const rdeieds = (
      await axios.get(`/empresas/${empresaId}/rde-ieds`, {
        params: { search },
      })
    ).data;
    const alertaGrupo = (await axios.get(`/empresas/${empresaId}/rde-ieds/verificar-alertas`)).data;
    return { rdeieds, alertaGrupo };
  } catch (e) {
    return thunkAPI.rejectWithValue(e);
  }
});

export const fetchRDEIED = createAsyncThunk("empresa/fetchRDEIED", async ({ empresaId, id }, thunkAPI) => {
  try {
    if (id === "create") return {};
    return (await axios.get(`/empresas/${empresaId}/rde-ieds/${id}`)).data;
  } catch (e) {
    return thunkAPI.rejectWithValue(e);
  }
});

// DEFs

export const fetchDEFs = createAsyncThunk("empresa/fetchDEFs", async ({ empresaId, search }, thunkAPI) => {
  try {
    if (typeof search !== "string") search = thunkAPI.getState().empresa.defsSearch;
    const defs = (await axios.get(`/empresas/${empresaId}/defs`, { params: { search } })).data;
    const alertaGrupo = (await axios.get(`/empresas/${empresaId}/defs/verificar-alertas`)).data;
    return { defs, alertaGrupo };
  } catch (e) {
    return thunkAPI.rejectWithValue(e);
  }
});

export const fetchDEF = createAsyncThunk("empresa/fetchDEF", async ({ empresaId, id }, thunkAPI) => {
  try {
    if (id === "create") return {};
    return (await axios.get(`/empresas/${empresaId}/defs/${id}`)).data;
  } catch (e) {
    return thunkAPI.rejectWithValue(e);
  }
});

// CCEs

export const fetchCCEs = createAsyncThunk("empresa/fetchCCEs", async ({ empresaId, search }, thunkAPI) => {
  try {
    if (typeof search !== "string") search = thunkAPI.getState().empresa.ccesSearch;
    const cces = (await axios.get(`/empresas/${empresaId}/cces`, { params: { search } })).data;
    const alertaGrupo = (await axios.get(`/empresas/${empresaId}/cces/verificar-alertas`)).data;
    return { cces, alertaGrupo };
  } catch (e) {
    return thunkAPI.rejectWithValue(e);
  }
});

export const fetchCCE = createAsyncThunk("empresa/fetchCCE", async ({ empresaId, id }, thunkAPI) => {
  try {
    if (id === "create") return {};
    return (await axios.get(`/empresas/${empresaId}/cces/${id}`)).data;
  } catch (e) {
    return thunkAPI.rejectWithValue(e);
  }
});

// CBEs

export const fetchCBEs = createAsyncThunk("empresa/fetchCBEs", async ({ empresaId, search }, thunkAPI) => {
  try {
    if (typeof search !== "string") search = thunkAPI.getState().empresa.cbesSearch;
    const cbes = (await axios.get(`/empresas/${empresaId}/cbes`, { params: { search } })).data;
    const alertaGrupo = (await axios.get(`/empresas/${empresaId}/cbes/verificar-alertas`)).data;
    return { cbes, alertaGrupo };
  } catch (e) {
    return thunkAPI.rejectWithValue(e);
  }
});

export const fetchCBE = createAsyncThunk("empresa/fetchCBE", async ({ empresaId, id }, thunkAPI) => {
  try {
    if (id === "create") return {};
    return (await axios.get(`/empresas/${empresaId}/cbes/${id}`)).data;
  } catch (e) {
    return thunkAPI.rejectWithValue(e);
  }
});

// LICENÇAS

export const fetchLicencas = createAsyncThunk("empresa/fetchLicencas", async ({ empresaId, search, filterDate, unidade }, thunkAPI) => {
  try {
    if (filterDate === undefined) {
      filterDate = thunkAPI.getState().empresa.licencasFilterDate;
    }

    if (unidade === undefined) {
      unidade = thunkAPI.getState().empresa.licencasUnidade;
    }

    if (typeof search !== "string") {
      search = thunkAPI.getState().empresa.licencasSearch;
    }
    const licencas = (
      await axios.get(`/empresas/${empresaId}/licencas`, {
        params: { search, filterDate, unidade },
      })
    ).data;
    const alertaGrupo = (await axios.get(`/empresas/${empresaId}/licencas/verificar-alertas`)).data;
    return { licencas, search, alertaGrupo, filterDate, unidade };
  } catch (e) {
    return thunkAPI.rejectWithValue(e);
  }
});

export const fetchLicenca = createAsyncThunk("empresa/fetchLicenca", async ({ empresaId, id }, thunkAPI) => {
  try {
    if (id === "create") return {};
    return (await axios.get(`/empresas/${empresaId}/licencas/${id}`)).data;
  } catch (e) {
    return thunkAPI.rejectWithValue(e);
  }
});

// DOCUMENTOS

export const fetchDocumentos = createAsyncThunk("empresa/fetchDocumentos", async ({ empresaId, search }, thunkAPI) => {
  try {
    if (typeof search !== "string") search = thunkAPI.getState().empresa.documentosSearch;
    const documentos = (
      await axios.get(`/empresas/${empresaId}/documentos`, {
        params: { search },
      })
    ).data;
    const alertaGrupo = (await axios.get(`/empresas/${empresaId}/documentos/verificar-alertas`)).data;
    return { documentos, search, alertaGrupo };
  } catch (e) {
    return thunkAPI.rejectWithValue(e);
  }
});

export const fetchDocumento = createAsyncThunk("empresa/fetchDocumento", async ({ empresaId, id }, thunkAPI) => {
  try {
    if (id === "create") return {};
    return (await axios.get(`/empresas/${empresaId}/documentos/${id}`)).data;
  } catch (e) {
    return thunkAPI.rejectWithValue(e);
  }
});

// LIVROS DIGITAIS

export const fetchLivrosDigitais = createAsyncThunk("empresa/fetchLivrosDigitais", async ({ empresaId, search }, thunkAPI) => {
  try {
    if (typeof search !== "string") search = thunkAPI.getState().empresa.livrosDigitaisSearch;
    const livrosDigitais = (
      await axios.get(`/empresas/${empresaId}/livros-digitais`, {
        params: { search },
      })
    ).data;
    const alertaGrupo = (await axios.get(`/empresas/${empresaId}/livros-digitais/verificar-alertas`)).data;
    return { livrosDigitais, alertaGrupo };
  } catch (e) {
    return thunkAPI.rejectWithValue(e);
  }
});

export const fetchLivroDigital = createAsyncThunk("empresa/fetchLivroDigital", async ({ empresaId, id }, thunkAPI) => {
  try {
    if (id === "create") return {};
    return (await axios.get(`/empresas/${empresaId}/livros-digitais/${id}`)).data;
  } catch (e) {
    return thunkAPI.rejectWithValue(e);
  }
});

// SLICE

export const slice = createSlice({
  name: "empresa",
  initialState,
  reducers: {},
  extraReducers: {
    // CABECALHO

    [fetchCabecalho.fulfilled]: (state, action) => {
      state.cabecalho = action.payload.cabecalho;
      state.cabecalho.acessoId = state.cabecalho?.acesso?.id;
    },

     // ASSISTENTE
    [fetchAssistente.fulfilled]: (state, action) => {
        // Atualiza o objeto assistente
        state.assistente = action.payload;

        // Atualiza os arrays separados
        state.socios = action.payload.socios || [];
        state.unidades = action.payload.unidades || [];
    },
    [fetchAssistente.rejected]: (state, action) => {
      state.assistente = { empresa: {}, unidades: [], socios: [] };
      state.socios = [];
      state.unidades = [];
    },

    // CADASTRO

    [fetchCadastro.fulfilled]: (state, action) => {
      state.cadastro = action.payload.cadastro;
      state.cadastro.acessoId = action.payload.cadastro?.acesso?.id;
      state.cadastroAlertaGrupo = action.payload.alertaGrupo;
    },
    [fetchCadastro.rejected]: (state, action) => {
      state.cadastro = [];
      state.cadastroAlertaGrupo = unwrapAlertaGrupo("cadastro", action);
    },

    // UNIDADES

    [fetchUnidades.fulfilled]: (state, action) => {
      state.unidades = action.payload.unidades;
      state.unidadesSearch = action.payload.search;
      state.unidadesAlertaGrupo = action.payload.alertaGrupo;
    },
    [fetchUnidades.rejected]: (state, action) => {
      state.unidades = [];
      state.unidadesSearch = "";
      state.unidadesAlertaGrupo = unwrapAlertaGrupo("unidades", action);
    },
    [fetchUnidade.fulfilled]: (state, action) => {
      state.unidade = action.payload;
      state.unidade.cnaePrimarioCodigo = action.payload.cnaePrimario?.codigo;
      state.unidade.cnaesSecundariosCodigos = action.payload.cnaesSecundarios?.map((it) => it.codigo);
    },

    // CERTIFICADOS

    [fetchCertificados.fulfilled]: (state, action) => {
      state.certificados = action.payload.certificados;
      state.certificadosSearch = action.payload.search;
      state.certificadosAlertaGrupo = action.payload.alertaGrupo;
    },
    [fetchCertificados.rejected]: (state, action) => {
      state.certificados = [];
      state.certificados = "";
      state.certificadosAlertaGrupo = unwrapAlertaGrupo("certificados", action);
    },
    [fetchCertificado.fulfilled]: (state, action) => {
      state.certificado = action.payload;
    },

    // TRIBUTARIOS

    [fetchTributarios.fulfilled]: (state, action) => {
      state.tributarios = action.payload.tributarios;
      state.tributariosSearch = action.payload.search;
      state.tributariosAlertaGrupo = action.payload.alertaGrupo;
    },
    [fetchTributarios.rejected]: (state, action) => {
      state.tributarios = [];
      state.tributarios = "";
      state.tributariosAlertaGrupo = unwrapAlertaGrupo("tributarios", action);
    },
    [fetchTributario.fulfilled]: (state, action) => {
      state.tributario = action.payload;
    },
    // SÓCIOS

    [fetchSocios.fulfilled]: (state, action) => {
      state.socios = action.payload.socios;
      state.sociosSearch = action.payload.search;
      state.sociosAlertaGrupo = action.payload.alertaGrupo;
    },
    [fetchSocios.rejected]: (state, action) => {
      state.socios = [];
      state.socios = "";
      state.sociosAlertaGrupo = unwrapAlertaGrupo("socios", action);
    },
    [fetchSocio.fulfilled]: (state, action) => {
      state.socio = action.payload;
    },

    // CONTRATOS

    [fetchContratos.fulfilled]: (state, action) => {
      state.contratos = action.payload.contratos;
      state.contratosOrgao = action.payload.orgao;
      state.contratosSearch = action.payload.search;
      state.contratosAlertaGrupo = action.payload.alertaGrupo;
    },
    [fetchContratos.rejected]: (state, action) => {
      state.contratos = [];
      state.contratos = "";
      state.contratosAlertaGrupo = unwrapAlertaGrupo("contratos", action);
    },
    [fetchContrato.fulfilled]: (state, action) => {
      state.contrato = action.payload;
      state.contrato.livroDigitalId = action.payload.livroDigital?.id;
    },

    // PLS

    [fetchPLs.fulfilled]: (state, action) => {
      state.pls = action.payload.pls;
      state.plsSearch = action.payload.search;
      state.plsAlertaGrupo = action.payload.alertaGrupo;
    },
    [fetchPLs.rejected]: (state, action) => {
      state.pls = [];
      state.pls = "";
      state.plsAlertaGrupo = unwrapAlertaGrupo("pls", action);
    },
    [fetchPL.fulfilled]: (state, action) => {
      state.pl = action.payload;
    },

    // ADMINISTRADORES

    [fetchAdministradores.fulfilled]: (state, action) => {
      state.administradores = action.payload.administradores;
      state.administradoresSearch = action.payload.search;
      state.administradoresAlertaGrupo = action.payload.alertaGrupo;
    },
    [fetchAdministradores.rejected]: (state, action) => {
      state.administradores = [];
      state.administradores = "";
      state.administradoresAlertaGrupo = unwrapAlertaGrupo("administradores", action);
    },
    [fetchAdministrador.fulfilled]: (state, action) => {
      state.administrador = action.payload;
    },

    // PROCURADORES

    [fetchProcuradores.fulfilled]: (state, action) => {
      state.procuradores = action.payload.procuradores;
      state.procuradoresSearch = action.payload.search;
      state.procuradoresAlertaGrupo = action.payload.alertaGrupo;
    },
    [fetchProcuradores.rejected]: (state, action) => {
      state.procuradores = [];
      state.procuradores = "";
      state.procuradoresAlertaGrupo = unwrapAlertaGrupo("procuradores", action);
    },
    [fetchProcurador.fulfilled]: (state, action) => {
      state.procurador = action.payload;
    },

    // CONTAS

    [fetchContas.fulfilled]: (state, action) => {
      state.contas = action.payload.contas;
      state.contasSearch = action.payload.search;
      state.contasAlertaGrupo = action.payload.alertaGrupo;
    },
    [fetchContas.rejected]: (state, action) => {
      state.contas = [];
      state.contas = "";
      state.contasAlertaGrupo = unwrapAlertaGrupo("contas", action);
    },
    [fetchConta.fulfilled]: (state, action) => {
      state.conta = action.payload;
    },

    // BENEFICIÁRIOS EMPRESA

    [fetchBeneficiariosEmpresa.fulfilled]: (state, action) => {
      state.beneficiariosEmpresa = action.payload.beneficiariosEmpresa;
      state.beneficiariosEmpresaSearch = action.payload.search;
      state.beneficiariosEmpresaAlertaGrupo = action.payload.alertaGrupo;
    },
    [fetchBeneficiariosEmpresa.rejected]: (state, action) => {
      state.beneficiariosEmpresa = [];
      state.beneficiariosEmpresa = "";
      state.beneficiariosEmpresaAlertaGrupo = unwrapAlertaGrupo("beneficiarios-empresa", action);
    },
    [fetchBeneficiarioEmpresa.fulfilled]: (state, action) => {
      state.beneficiarioEmpresa = action.payload;
    },

    // REPRESENTANTES

    [fetchRepresentantes.fulfilled]: (state, action) => {
      state.representantes = action.payload.representantes;
      state.representantesSearch = action.payload.search;
      state.representantesAlertaGrupo = action.payload.alertaGrupo;
    },
    [fetchRepresentantes.rejected]: (state, action) => {
      state.representantes = [];
      state.representantes = "";
      state.representantesAlertaGrupo = unwrapAlertaGrupo("representantes", action);
    },
    [fetchRepresentante.fulfilled]: (state, action) => {
      state.representante = action.payload;
      state.representante.socioId = action.payload.socio?.id;
    },

    // BENEFICIÁRIOS SÓCIO

    [fetchBeneficiariosSocio.fulfilled]: (state, action) => {
      state.beneficiariosSocio = action.payload.beneficiariosSocio;
      state.beneficiariosSocioSearch = action.payload.search;
      state.beneficiariosSocioAlertaGrupo = action.payload.alertaGrupo;
    },
    [fetchBeneficiariosSocio.rejected]: (state, action) => {
      state.beneficiariosSocio = [];
      state.beneficiariosSocio = "";
      state.beneficiariosSocioAlertaGrupo = unwrapAlertaGrupo("beneficiarios-socio", action);
    },
    [fetchBeneficiarioSocio.fulfilled]: (state, action) => {
      state.beneficiarioSocio = action.payload;
      state.beneficiarioSocio.socioId = action.payload.socio?.id;
    },

    // RDEIEDS

    [fetchRDEIEDs.fulfilled]: (state, action) => {
      state.rdeieds = action.payload.rdeieds;
      state.rdeiedsSearch = action.payload.search;
      state.rdeiedsAlertaGrupo = action.payload.alertaGrupo;
    },
    [fetchRDEIEDs.rejected]: (state, action) => {
      state.rdeieds = [];
      state.rdeieds = "";
      state.rdeiedsAlertaGrupo = unwrapAlertaGrupo("rde-ieds", action);
    },
    [fetchRDEIED.fulfilled]: (state, action) => {
      state.rdeied = action.payload;
      state.rdeied.socioId = action.payload.socio?.id;
    },

    // DEFs

    [fetchDEFs.fulfilled]: (state, action) => {
      state.defs = action.payload.defs;
      state.defsSearch = action.payload.search;
      state.defsAlertaGrupo = action.payload.alertaGrupo;
    },
    [fetchDEFs.rejected]: (state, action) => {
      state.defs = [];
      state.defs = "";
      state.defsAlertaGrupo = unwrapAlertaGrupo("defs", action);
    },
    [fetchDEF.fulfilled]: (state, action) => {
      state.def = action.payload;
    },

    // CCEs

    [fetchCCEs.fulfilled]: (state, action) => {
      state.cces = action.payload.cces;
      state.ccesSearch = action.payload.search;
      state.ccesAlertaGrupo = action.payload.alertaGrupo;
    },
    [fetchCCEs.rejected]: (state, action) => {
      state.cces = [];
      state.cces = "";
      state.ccesAlertaGrupo = unwrapAlertaGrupo("cces", action);
    },
    [fetchCCE.fulfilled]: (state, action) => {
      state.cce = action.payload;
    },

    // CBEs

    [fetchCBEs.fulfilled]: (state, action) => {
      state.cbes = action.payload.cbes;
      state.cbesSearch = action.payload.search;
      state.cbesAlertaGrupo = action.payload.alertaGrupo;
    },
    [fetchCBEs.rejected]: (state, action) => {
      state.cbes = [];
      state.cbes = "";
      state.cbesAlertaGrupo = unwrapAlertaGrupo("cbes", action);
    },
    [fetchCBE.fulfilled]: (state, action) => {
      state.cbe = action.payload;
    },

    // LICENÇAS

    [fetchLicencas.fulfilled]: (state, action) => {
      state.licencas = action.payload.licencas;
      state.licencasSearch = action.payload.search;
      state.licencasFilterDate = action.payload.filterDate;
      state.licencasUnidade = action.payload.unidade;
      state.licencasAlertaGrupo = action.payload.alertaGrupo;
    },
    [fetchLicencas.rejected]: (state, action) => {
      state.licencas = [];
      state.licencas = "";
      state.licencasAlertaGrupo = unwrapAlertaGrupo("licencas", action);
    },
    [fetchLicenca.fulfilled]: (state, action) => {
      state.licenca = action.payload;
      state.licenca.unidadeId = action.payload.unidade?.id;
    },

    // DOCUMENTOS

    [fetchDocumentos.fulfilled]: (state, action) => {
      state.documentos = action.payload.documentos;
      state.documentosSearch = action.payload.search;
      state.documentosAlertaGrupo = action.payload.alertaGrupo;
    },
    [fetchDocumentos.rejected]: (state, action) => {
      state.documentos = [];
      state.documentos = "";
      state.documentosAlertaGrupo = unwrapAlertaGrupo("documentos", action);
    },
    [fetchDocumento.fulfilled]: (state, action) => {
      state.documento = action.payload;
      state.documento.unidadeId = action.payload.unidade?.id;
    },

    // LIVROS DIGITAIS

    [fetchLivrosDigitais.fulfilled]: (state, action) => {
      state.livrosDigitais = action.payload.livrosDigitais;
      state.livrosDigitaisSearch = action.payload.search;
      state.livrosDigitaisAlertaGrupo = action.payload.alertaGrupo;
    },
    [fetchLivrosDigitais.rejected]: (state, action) => {
      state.livrosDigitais = [];
      state.livrosDigitais = "";
      state.livrosDigitaisAlertaGrupo = unwrapAlertaGrupo("livros-digitais", action);
    },
    [fetchLivroDigital.fulfilled]: (state, action) => {
      state.livroDigital = action.payload;
      state.livroDigital.conteudos.forEach((conteudo) => {
        conteudo.contratoId = conteudo.contrato?.id;
      });
    },
  },
});

export default slice.reducer;

// UTIL

function unwrapAlertaGrupo(nome, action) {
  return {
    nome,
    nivel: 2,
    alertas: [{ nivel: 2, mensagem: action.payload.mensagem }],
  };
}
